import PassEntryParam from '@/components/PassEntryParam'
import GoodsInfo from '@/components/GoodsInfo'
import SuperviseTools from '@/components/SuperviseTools'
import SuperviseToolsDetail from '@/components/SuperviseToolsDetail'
import ExemptionNature from '@/components/ExemptionNature'
import ExemptionNatureDetail from '@/components/ExemptionNatureDetail'
import AreaNatureDetail from '@/components/AreaNatureDetail'
import AreaNature from '@/components/AreaNature'
import CompanyNatureDetail from '@/components/CompanyNatureDetail'
import CompanyNature from '@/components/CompanyNature'
import CountryDetail from '@/components/CountryDetail'
import Country from '@/components/Country'
import CurrencyDetail from '@/components/CurrencyDetail'
import Currency from '@/components/Currency'
import CustomsDetail from '@/components/CustomsDetail'
import Customs from '@/components/Customs'
import ExchangeSettlementDetail from '@/components/ExchangeSettlementDetail'
import ExchangeSettlement from '@/components/ExchangeSettlement'
import ExemptionReliefWayDetail from '@/components/ExemptionReliefWayDetail'
import ExemptionReliefWay from '@/components/ExemptionReliefWay'
import LocationAreaDetail from '@/components/LocationAreaDetail'
import LocationArea from '@/components/LocationArea'
import RegulatoryDocDetail from '@/components/RegulatoryDocDetail'
import RegulatoryDocDetailItem from '@/components/RegulatoryDocDetail_Item'
import RegulatoryDoc from '@/components/RegulatoryDoc'
import ShappingModeDetail from '@/components/ShappingModeDetail'
import ShappingMode from '@/components/ShappingMode'
import TransactionMethod from '@/components/TransactionMethod'
import TransactionMethodDetail from '@/components/TransactionMethodDetail'
import UnitsDetail from '@/components/UnitsDetail'
import Units from '@/components/Units'
import UseToDetail from '@/components/UseToDetail'
import UseTo from '@/components/UseTo'
import MyCustoms from '@/components/MyCustoms'
import TradeStateLeaderPage from '../components/TradeStateLeaderPage.vue'
import TaxCalculator from '@/components/TaxCalculator'
import PolicyDoc from '@/components/PolicyDoc'
import CustomsPolicyDoc from '@/components/CustomsPolicyDoc'
import PolicyDocDetail from '@/components/PolicyDocDetail'
import HandBookStat from '@/components/HandBookStat'
import ImportTariff from '@/components/ImportTariff'
import ImportTariffDetail from '@/components/ImportTariffDetail'
import DeclareKeyElement from '@/components/DeclareKeyElement'
import DeclareKeyElementDetail from '@/components/DeclareKeyElementDetail'
import ImportLinkageTax from '@/components/ImportLinkageTax'
import ImportLinkageTaxDetail from '@/components/ImportLinkageTaxDetail'
import ExportTax from '@/components/ExportTax'
import ExportTaxDetail from '@/components/ExportTaxDetail'
import ExportRebates from '@/components/ExportRebates'
import ExportRebatesDetail from '@/components/ExportRebatesDetail'
import gUnit from '@/components/G_Unit'
import gUnitDetail from '@/components/G_UnitDetail'
import Licensed from '@/components/Licensed'
import LicensedDetail from '@/components/LicensedDetail'
import IMLicensed from '@/components/IMLicensed'
import IMLicensedDetail from '@/components/IMLicensedDetail'
import ExportLicensed from '@/components/ExportLicensed'
import ExportLicensedDetail from '@/components/ExportLicensedDetail'
import UpdateLog from '@/components/UpdateLog'
import UpdateLogByDateTime from '@/components/UpdateLogByDateTime'
import UpdateLogDetail from '@/components/UpdateLogDetail'
import DeclareKeyElementStat from '@/components/DeclareKeyElementStat'
import DelcareKeyElementStatDetail from '@/components/DelcareKeyElementStatDetail'
import IMGoodsInfoHSDetail from '@/components/IMGoodsInfoHSDetail'
import IMGoodsInfoHS from '@/components/IMGoodsInfoHS'
import OMGoodsInfoHSDetail from '@/components/OMGoodsInfoHSDetail'
import OMGoodsInfoHS from '@/components/OMGoodsInfoHS'
import EXGoods from '@/components/EXGoods'
import EXGoodsDetail from '@/components/ExGoodsDetail'
import EntryGoods from '@/components/EntryGoods'
import EntryGoodsDetail from '@/components/EntryGoodsDetail'
import GoodsInfoHSStat from '@/components/GoodsInfoHSStat'
import CustomsGuideDetail from '@/components/CustomsGuideDetail'
import CustomsGuide from '@/components/CustomsGuide'
import CiqDetail from '@/components/CiqDetail'
import CiqSearch from '@/components/CiqSearch'
import CiqSearchListByCode from '@/components/CiqSearchListByCode'
import CiqSearchListByHS from '@/components/CiqSearchListByHS'
import StatsDir from '@/components/StatsDir'
import StatsDirSearchResult from '@/components/StatsDirSearchResult'
import StatsDirDetail from '@/components/StatsDirDetail'
import StatsDirYearList from '@/components/StatsDirYearList'
import MainGoods from '@/components/MainGoods'
import MainGoodsSearchResult from '@/components/MainGoodsSearchResult'
import MainGoodsSearchDetail from '@/components/MainGoodsSearchDetail'
import MainGoodsYearList from '@/components/MainGoodsYearList'
import UnitConvert from '@/components/UnitConvert'
import UnitConvertQuery from '@/components/UnitConvertQuery'
import TaxLicensed from '@/components/TaxLicensed'
import PContainerModels from '@/components/P_ContainerModels'
import PDangerousGoods from '@/components/P_DangerousGoods'
import PDomesticPorts from '@/components/P_DomesticPorts'
import PGoodsProperty from '@/components/P_GoodsProperty'
import PInspectionQuarantinek from '@/components/P_InspectionQuarantinek'
import POriginCountry from '@/components/P_OriginCountry'
import PPackingType from '@/components/P_PackingType'
import PPermitType from '@/components/P_PermitType'
import PPortType from '@/components/P_PortType'
import PRelatedReasons from '@/components/P_RelatedReasons'
import PContainerModelsDetail from '@/components/P_ContainerModelsDetail'
import PDangerousGoodsDetail from '@/components/P_DangerousGoodsDetail'
import PDomesticPortsDetail from '@/components/P_DomesticPortsDetail'
import PGoodsPropertyDetail from '@/components/P_GoodsPropertyDetail'
import PInspectionQuarantinekDetail from '@/components/P_InspectionQuarantinekDetail'
import POriginCountryDetail from '@/components/P_OriginCountryDetail'
import PPackingTypeDetail from '@/components/P_PackingTypeDetail'
import PPermitTypeDetail from '@/components/P_PermitTypeDetail'
import PPortTypeDetail from '@/components/P_PortTypeDetail'
import PRelatedReasonsDetail from '@/components/P_RelatedReasonsDetail'
import TradeState from '@/components/TradeState'
import TradeStateChart from '@/components/TradeStateChart'
import NoPower from '@/components/NoPower'
import PCIQDoc from '@/components/P_CIQDoc'
import PCIQDocDetail from '@/components/P_CIQDocDetail'
import ExportRebatesHS from '@/components/ExportRebates_HS'
import ExportRebatesHSDetail from '@/components/ExportRebates_HSDetail'
import GUnitHS from '@/components/G_Unit_HS'
import GUnitHSDetail from '@/components/G_Unit_HSDetail'
import ImportLinkageTaxHS from '@/components/ImportLinkageTax_HS'
import ImportLinkageTaxHSDetail from '@/components/ImportLinkageTax_HSDetail'
import AntiDumpingHS from '@/components/AntiDumping_HS'
import AntiDumpingHSDetail from '@/components/AntiDumping_HSDetail'
import AntiDumpingHSCompanyDetail from '@/components/AntiDumping_HSCompanyDetail'
import HandBookAntiDumping from '@/components/HandBookAntiDumping'
import HandBookAntiDumpingDetail from '@/components/HandBookAntiDumpingDetail'
import HandBookAntiDumpingCompanyDetail from '@/components/HandBookAntiDumpingCompanyDetail'
import UseHelper from '@/components/UseHelper'
import HazardousChemicalsHS from '@/components/HazardousChemicals_HS'
import HazardousChemicalsHSDetail from '@/components/HazardousChemicals_HSDetail'
import RulesSearchIndex from '@/components/RulesSearchIndex'
import RulesSearchDetails from '@/components/RulesSearchDetails'
import FoodRulesSearchIndex from '@/components/FoodRulesSearchIndex'
import FoodRulesSearchDetails from '@/components/FoodRulesSearchDetails'
import TradeStateByData from '@/components/TradeStateByData'
import TradeStateByDataQuery from '@/components/TradeStateByDataQuery'
import TradeStateByDataDetails from '@/components/TradeStateByDataDetails'
import TradeStateByDataEnglish from '@/components/Trade/en/TradeStateByData'
import TradeStateByDataQueryEnglish from '@/components/Trade/en/TradeStateByDataQuery'
import TradeStateByDataDetailsEnglish from '@/components/Trade/en/TradeStateByDataDetails'
import ExpertIndex from '@/components/ExpertIndex'
import ExpertDetails from '@/components/ExpertDetails'
import BindExpertIndex from '@/components/BindExpertIndex'
import BindExpertDetails from '@/components/BindExpertDetails'
import GoodsSizeQuery from '@/components/GoodsSizeQuery'
import GoodsSizeDetails from '@/components/GoodsSizeDetails'
import GoodsSizeQueryTOP from '@/components/GoodsSizeQueryTOP'
import OpenInOtherMethod from '@/components/OpenInOtherMethod'
import PInvoices from '@/components/P_Invoices'
import PInvoicesDetail from '@/components/P_InvoicesDetail'
import PUNCode from '@/components/P_UNCode'
import PUNCodeDetail from '@/components/P_UNCodeDetail'
import FoodRulesSearchLeaderPage from '@/components/FoodRulesSearchLeaderPage'
import FoodRulesSearchOfReport from '@/components/FoodRulesSearchOfReport'
import FoodRulesSearchOfRule from '@/components/FoodRulesSearchOfRule'
import FoodRulesLoginPage from '@/components/FoodRulesLoginPage'
import FoodRulesRegisterPage from '@/components/FoodRulesRegisterPage'
import FoodRulesFindPassPage from '@/components/FoodRulesFindPassPage'
import DownloadNoticeFiles from '@/components/DownloadNoticeFiles'
import NodeSearchByDataDetails from '@/components/NodeSearchByDataDetails'
import NodeSearchByDataQuery from '@/components/NodeSearchByDataQuery'
import NodeSearchFindPassPage from '@/components/NodeSearchFindPassPage'
import NodeSearchLeaderPage from '@/components/NodeSearchLeaderPage'
import NodeSearchLoginPage from '@/components/NodeSearchLoginPage'
import NodeSearchRegisterPage from '@/components/NodeSearchRegisterPage'
import NodeSearchOneDetail from '@/components/NodeSearchOneDetail'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};




const routes = [
  {
    path: '/MyCustoms',
    name: 'MyCustoms',
    component: MyCustoms,
    meta: {title: '我的订制'}
  },
  {
    path: '/PassEntryParam',
    name: 'PassEntryParam',
    component: PassEntryParam,
    meta: {title: '通关参数'}
  },
  {
    path: '/GoodsInfo',
    name: 'GoodsInfo',
    component: GoodsInfo,
    meta: {title: '商品信息'}
  },
  {
    path: '/',
    name: 'homepage',
    component: GoodsInfo,
    meta: {title: '商品信息'}
  },
  {
    path: '/SuperviseTools',
    name: 'SuperviseTools',
    component: SuperviseTools,
    meta: {title: '监管方式'}
  },
  {
    path: '/SuperviseToolsDetail',
    name: 'SuperviseToolsDetail',
    component: SuperviseToolsDetail,
    meta: {title: '监管方式详情'}
  },
  {
    path: '/ExemptionNature',
    name: 'ExemptionNature',
    component: ExemptionNature,
    meta: {title: '征免方式'}
  },
  {
    path: '/ExemptionNatureDetail',
    name: 'ExemptionNatureDetail',
    component: ExemptionNatureDetail,
    meta: {title: '征免方式详情'}
  },
  {
    path: '/AreaNatureDetail',
    name: 'AreaNatureDetail',
    component: AreaNatureDetail,
    meta: {title: '地区性质详情'}
  },
  {
    path: '/AreaNature',
    name: 'AreaNature',
    component: AreaNature,
    meta: {title: '地区性质'}
  },
  {
    path: '/CompanyNatureDetail',
    name: 'CompanyNatureDetail',
    component: CompanyNatureDetail,
    meta: {title: '企业性质详情'}
  },
  {
    path: '/CompanyNature',
    name: 'CompanyNature',
    component: CompanyNature,
    meta: {title: '企业性质'}
  },
  {
    path: '/CountryDetail',
    name: 'CountryDetail',
    component: CountryDetail,
    meta: {title: '国家地区详情'}
  },
  {
    path: '/Country',
    name: 'Country',
    component: Country,
    meta: {title: '国家地区'}
  },
  {
    path: '/CurrencyDetail',
    name: 'CurrencyDetail',
    component: CurrencyDetail,
    meta: {title: '货币详情'}
  },
  {
    path: '/Currency',
    name: 'Currency',
    component: Currency,
    meta: {title: '货币'}
  },
  {
    path: '/CustomsDetail',
    name: 'CustomsDetail',
    component: CustomsDetail,
    meta: {title: '关区代码详情'}
  },
  {
    path: '/Customs',
    name: 'Customs',
    component: Customs,
    meta: {title: '关区代码'}
  },
  {
    path: '/ExchangeSettlementDetail',
    name: 'ExchangeSettlementDetail',
    component: ExchangeSettlementDetail,
    meta: {title: '结汇方式详情'}
  },
  {
    path: '/ExchangeSettlement',
    name: 'ExchangeSettlement',
    component: ExchangeSettlement,
    meta: {title: '结汇方式'}
  },
  {
    path: '/ExemptionReliefWayDetail',
    name: 'ExemptionReliefWayDetail',
    component: ExemptionReliefWayDetail,
    meta: {title: '征减免方式详情'}
  },
  {
    path: '/ExemptionReliefWay',
    name: 'ExemptionReliefWay',
    component: ExemptionReliefWay,
    meta: {title: '征减免方式'}
  },
  {
    path: '/LocationAreaDetail',
    name: 'LocationAreaDetail',
    component: LocationAreaDetail,
    meta: {title: '国内地区详情'}
  },
  {
    path: '/LocationArea',
    name: 'LocationArea',
    component: LocationArea,
    meta: {title: '国内地区'}
  },
  {
    path: '/RegulatoryDocDetail',
    name: 'RegulatoryDocDetail',
    component: RegulatoryDocDetail,
    meta: {title: '监管证件详情'}
  },
  {
    path: '/RegulatoryDocDetail_Item',
    name: 'RegulatoryDocDetail_Item',
    component: RegulatoryDocDetailItem,
    meta: {title: '监管证件详情'}
  },
  {
    path: '/RegulatoryDoc',
    name: 'RegulatoryDoc',
    component: RegulatoryDoc,
    meta: {title: '监管证件'}
  },
  {
    path: '/ShappingModeDetail',
    name: 'ShappingModeDetail',
    component: ShappingModeDetail,
    meta: {title: '运输方式'}
  },
  {
    path: '/ShappingMode',
    name: 'ShappingMode',
    component: ShappingMode,
    meta: {title: '运输方式'}
  },
  {
    path: '/TransactionMethodDetail',
    name: 'TransactionMethodDetail',
    component: TransactionMethodDetail,
    meta: {title: '成交方式详细'}
  },
  {
    path: '/TransactionMethod',
    name: 'TransactionMethod',
    component: TransactionMethod,
    meta: {title: '成交方式'}
  },
  {
    path: '/UnitsDetail',
    name: 'UnitsDetail',
    component: UnitsDetail,
    meta: {title: '计量单位表'}
  },
  {
    path: '/Units',
    name: 'Units',
    component: Units,
    meta: {title: '计量单位表'}
  },
  {
    path: '/UseToDetail',
    name: 'UseToDetail',
    component: UseToDetail,
    meta: {title: '用途'}
  },
  {
    path: '/UseTo',
    name: 'UseTo',
    component: UseTo,
    meta: {title: '用途'}
  },
  {
    path: '/TaxCalculator',
    name: 'TaxCalculator',
    component: TaxCalculator,
    meta: {title: '模拟计税'}
  },
  {
    path: '/PolicyDoc',
    name: 'PolicyDoc',
    component: PolicyDoc,
    meta: {title: '监管法规'}
  },
  {
    path: '/CustomsPolicyDoc',
    name: 'CustomsPolicyDoc',
    component: CustomsPolicyDoc,
    meta: {title: '关税法规'}
  },
  {
    path: '/PolicyDocDetail',
    name: 'PolicyDocDetail',
    component: PolicyDocDetail,
    meta: {title: '法规详情', keepAlive: false}
  },
  {
    path: '/ImportTariff',
    name: 'ImportTariff',
    component: ImportTariff,
    meta: {title: '进口关税'}
  },
  {
    path: '/ImportTariffDetail',
    name: 'ImportTariffDetail',
    component: ImportTariffDetail,
    meta: {title: '进口关税'}
  },
  {
    path: '/DeclareKeyElement',
    name: 'DeclareKeyElement',
    component: DeclareKeyElement,
    meta: {title: '申报要素'}
  },
  {
    path: '/DeclareKeyElementDetail',
    name: 'DeclareKeyElementDetail',
    component: DeclareKeyElementDetail,
    meta: {title: '申报要素'}
  },
  {
    path: '/ImportLinkageTax',
    name: 'ImportLinkageTax',
    component: ImportLinkageTax,
    meta: {title: '进口环节税'}
  },
  {
    path: '/ImportLinkageTaxDetail',
    name: 'ImportLinkageTaxDetail',
    component: ImportLinkageTaxDetail,
    meta: {title: '进口环节税'}
  },
  {
    path: '/ExportTax',
    name: 'ExportTax',
    component: ExportTax,
    meta: {title: '出口关税'}
  },
  {
    path: '/ExportTaxDetail',
    name: 'ExportTaxDetail',
    component: ExportTaxDetail,
    meta: {title: '出口关税'}
  },
  {
    path: '/ExportRebates',
    name: 'ExportRebates',
    component: ExportRebates,
    meta: {title: '出口退税'}
  },
  {
    path: '/ExportRebatesDetail',
    name: 'ExportRebatesDetail',
    component: ExportRebatesDetail,
    meta: {title: '出口退税'}
  },
  {
    path: '/G_Unit',
    name: 'G_Unit',
    component: gUnit,
    meta: {title: '计量单位'}
  },
  {
    path: '/G_UnitDetail',
    name: 'G_UnitDetail',
    component: gUnitDetail,
    meta: {title: '计量单位'}
  },
  {
    path: '/Licensed',
    name: 'Licensed',
    component: Licensed,
    meta: {title: '监管证件'}
  },
  {
    path: '/LicensedDetail',
    name: 'LicensedDetail',
    component: LicensedDetail,
    meta: {title: '监管证件'}
  },
  {
    path: '/IMLicensed',
    name: 'IMLicensed',
    component: IMLicensed,
    meta: {title: '进口证件'}
  },
  {
    path: '/IMLicensedDetail',
    name: 'IMLicensedDetail',
    component: IMLicensedDetail,
    meta: {title: '进口证件'}
  },
  {
    path: '/ExportLicensed',
    name: 'ExportLicensed',
    component: ExportLicensed,
    meta: {title: '出口证件'}
  },
  {
    path: '/ExportLicensedDetail',
    name: 'ExportLicensedDetail',
    component: ExportLicensedDetail,
    meta: {title: '出口证件'}
  },
  {
    path: '/UpdateLog',
    name: 'UpdateLog',
    component: UpdateLog,
    meta: {title: '更新日志'}
  },
  {
    path: '/UpdateLogByDateTime',
    name: 'UpdateLogByDateTime',
    component: UpdateLogByDateTime,
    meta: {title: '更新日志'}
  },
  {
    path: '/UpdateLogDetail',
    name: 'UpdateLogDetail',
    component: UpdateLogDetail,
    meta: {title: '更新日志'}
  },
  {
    path: '/HandBookStat',
    name: 'HandBookStat',
    component: HandBookStat,
    meta: {title: '手册统计'}
  },
  {
    path: '/DeclareKeyElementStat',
    name: 'DeclareKeyElementStat',
    component: DeclareKeyElementStat,
    meta: {title: '申报要素统计'}
  },
  {
    path: '/DelcareKeyElementStatDetail',
    name: 'DelcareKeyElementStatDetail',
    component: DelcareKeyElementStatDetail,
    meta: {title: '申报要素统计'}
  },
  {
    path: '/IMGoodsInfoHSDetail',
    name: 'IMGoodsInfoHSDetail',
    component: IMGoodsInfoHSDetail,
    meta: {title: '进口税则'}
  },
  {
    path: '/IMGoodsInfoHS',
    name: 'IMGoodsInfoHS',
    component: IMGoodsInfoHS,
    meta: {title: '进口税则'}
  },
  {
    path: '/OMGoodsInfoHSDetail',
    name: 'OMGoodsInfoHSDetail',
    component: OMGoodsInfoHSDetail,
    meta: {title: '出口税则'}
  },
  {
    path: '/OMGoodsInfoHS',
    name: 'OMGoodsInfoHS',
    component: OMGoodsInfoHS,
    meta: {title: '出口税则'}
  },
  {
    path: '/EXGoodsDetail',
    name: 'EXGoodsDetail',
    component: EXGoodsDetail,
    meta: {title: 'EX信息技术产品'}
  },
  {
    path: '/EXGoods',
    name: 'EXGoods',
    component: EXGoods,
    meta: {title: 'EX信息技术产品'}
  },
  {
    path: '/EntryGoods',
    name: 'EntryGoods',
    component: EntryGoods,
    meta: {title: '进境物品'}
  },
  {
    path: '/EntryGoodsDetail',
    name: 'EntryGoodsDetail',
    component: EntryGoodsDetail,
    meta: {title: '进境物品'}
  },
  {
    path: '/GoodsInfoHSStat',
    name: 'GoodsInfoHSStat',
    component: GoodsInfoHSStat,
    meta: {title: '税则统计'}
  },
  {
    path: '/CustomsGuide',
    name: 'CustomsGuide',
    component: CustomsGuide,
    meta: {title: '税则统计'}
  },
  {
    path: '/CustomsGuideDetail',
    name: 'CustomsGuideDetail',
    component: CustomsGuideDetail,
    meta: {title: '税则统计'}
  },
  {
    path: '/CiqDetail',
    name: 'CiqDetail',
    component: CiqDetail,
    meta: {title: 'CIQ编码'}
  },
  {
    path: '/CiqSearch',
    name: 'CiqSearch',
    component: CiqSearch,
    meta: {title: 'CIQ编码'}
  },
  {
    path: '/CiqSearchListByCode',
    name: 'CiqSearchListByCode',
    component: CiqSearchListByCode,
    meta: {title: 'CIQ编码'}
  },
  {
    path: '/CiqSearchListByHS',
    name: 'CiqSearchListByHS',
    component: CiqSearchListByHS,
    meta: {title: 'CIQ编码'}
  },
  {
    path: '/StatsDir',
    name: 'StatsDir',
    component: StatsDir,
    meta: {title: '统计目录'}
  },
  {
    path: '/StatsDirSearchResult',
    name: 'StatsDirSearchResult',
    component: StatsDirSearchResult,
    meta: {title: '统计目录搜索结果'}
  },
  {
    path: '/StatsDirDetail',
    name: 'StatsDirDetail',
    component: StatsDirDetail,
    meta: {title: '统计目录详情'}
  },
  {
    path: '/StatsDirYearList',
    name: 'StatsDirYearList',
    component: StatsDirYearList,
    meta: {title: '统计目录'}
  },
  {
    path: '/MainGoods',
    name: 'MainGoods',
    component: MainGoods,
    meta: {title: '主要商品'}
  },
  {
    path: '/MainGoodsSearchResult',
    name: 'MainGoodsSearchResult',
    component: MainGoodsSearchResult,
    meta: {title: '主要商品'}
  },
  {
    path: '/MainGoodsSearchDetail',
    name: 'MainGoodsSearchDetail',
    component: MainGoodsSearchDetail,
    meta: {title: '主要商品'}
  },
  {
    path: '/MainGoodsYearList',
    name: 'MainGoodsYearList',
    component: MainGoodsYearList,
    meta: {title: '主要商品'}
  },
  {
    path: '/UnitConvert',
    name: 'UnitConvert',
    component: UnitConvert,
    meta: {title: '单位换算'}
  },
  {
    path: '/UnitConvertQuery',
    name: 'UnitConvertQuery',
    component: UnitConvertQuery,
    meta: {title: '单位换算'}
  },
  {
    path: '/TaxLicensed',
    name: 'TaxLicensed',
    component: TaxLicensed,
    meta: {title: '税费证件'}
  },
  {
    path: '/PContainerModels',
    name: 'PContainerModels',
    component: PContainerModels,
    meta: {title: '集装箱规格型号'}
  },
  {
    path: '/PContainerModelsDetail',
    name: 'PContainerModelsDetail',
    component: PContainerModelsDetail,
    meta: {title: '集装箱规格型号'}
  },
  {
    path: '/PDangerousGoods',
    name: 'PDangerousGoods',
    component: PDangerousGoods,
    meta: {title: '危包规格'}
  },
  {
    path: '/PDangerousGoodsDetail',
    name: 'PDangerousGoodsDetail',
    component: PDangerousGoodsDetail,
    meta: {title: '危险物品'}
  },
  {
    path: '/PDomesticPorts',
    name: 'PDomesticPorts',
    component: PDomesticPorts,
    meta: {title: '国内口岸'}
  },
  {
    path: '/PGoodsProperty',
    name: 'PGoodsProperty',
    component: PGoodsProperty,
    meta: {title: '货物属性'}
  },
  {
    path: '/PInspectionQuarantinek',
    name: 'PInspectionQuarantinek',
    component: PInspectionQuarantinek,
    meta: {title: '检验检疫机关'}
  },
  {
    path: '/POriginCountry',
    name: 'POriginCountry',
    component: POriginCountry,
    meta: {title: '原产国'}
  },
  {
    path: '/PPackingType',
    name: 'PPackingType',
    component: PPackingType,
    meta: {title: '包装种类'}
  },
  {
    path: '/PPermitType',
    name: 'PPermitType',
    component: PPermitType,
    meta: {title: '企业产品许可类别'}
  },
  {
    path: '/PPortType',
    name: 'PPortType',
    component: PPortType,
    meta: {title: '港口代码'}
  },
  {
    path: '/PRelatedReasons',
    name: 'PRelatedReasons',
    component: PRelatedReasons,
    meta: {title: '关联理由'}
  },
  {
    path: '/PDomesticPortsDetail',
    name: 'PDomesticPortsDetail',
    component: PDomesticPortsDetail,
    meta: {title: '国内口岸'}
  },
  {
    path: '/PGoodsPropertyDetail',
    name: 'PGoodsPropertyDetail',
    component: PGoodsPropertyDetail,
    meta: {title: '货物属性'}
  },
  {
    path: '/PInspectionQuarantinekDetail',
    name: 'PInspectionQuarantinekDetail',
    component: PInspectionQuarantinekDetail,
    meta: {title: '检验检疫机关'}
  },
  {
    path: '/POriginCountryDetail',
    name: 'POriginCountryDetail',
    component: POriginCountryDetail,
    meta: {title: '原产国'}
  },
  {
    path: '/PPackingTypeDetail',
    name: 'PPackingTypeDetail',
    component: PPackingTypeDetail,
    meta: {title: '包装种类'}
  },
  {
    path: '/PPermitTypeDetail',
    name: 'PPermitTypeDetail',
    component: PPermitTypeDetail,
    meta: {title: '企业产品许可类别'}
  },
  {
    path: '/PPortTypeDetail',
    name: 'PPortTypeDetail',
    component: PPortTypeDetail,
    meta: {title: '港口代码'}
  },
  {
    path: '/PRelatedReasonsDetail',
    name: 'PRelatedReasonsDetail',
    component: PRelatedReasonsDetail,
    meta: {title: '关联理由'}
  },
  {
    path: '/TradeState',
    name: 'TradeState',
    component: TradeState,
    meta: {title: '贸易统计'}
  },
  {
    path: '/TradeStateChart',
    name: 'TradeStateChart',
    component: TradeStateChart,
    meta: {title: '贸易统计'}
  },
  {
    path: '/NoPower',
    name: 'NoPower',
    component: NoPower,
    meta: {title: '无权限访问'}
  },
  {
    path: '/PCIQDocDetail',
    name: 'PCIQDocDetail',
    component: PCIQDocDetail,
    meta: {title: '检验检疫类别详情'}
  },
  {
    path: '/PCIQDoc',
    name: 'PCIQDoc',
    component: PCIQDoc,
    meta: {title: '检验检疫类别'}
  },
  {
    path: '/UseHelper',
    name: 'UseHelper',
    component: UseHelper,
    meta: {title: '使用说明'}
  },
  {
    path: '/ExportRebates_HS',
    name: 'ExportRebates_HS',
    component: ExportRebatesHS,
    meta: {title: '出口退税'}
  },
  {
    path: '/ExportRebates_HSDetail',
    name: 'ExportRebates_HSDetail',
    component: ExportRebatesHSDetail,
    meta: {title: '出口退税'}
  },
  {
    path: '/G_Unit_HS',
    name: 'G_Unit_HS',
    component: GUnitHS,
    meta: {title: '计量单位'}
  },
  {
    path: '/G_Unit_HSDetail',
    name: 'G_Unit_HSDetail',
    component: GUnitHSDetail,
    meta: {title: '计量单位'}
  },
  {
    path: '/ImportLinkageTax_HS',
    name: 'ImportLinkageTax_HS',
    component: ImportLinkageTaxHS,
    meta: {title: '代征税'}
  },
  {
    path: '/ImportLinkageTax_HSDetail',
    name: 'ImportLinkageTax_HSDetail',
    component: ImportLinkageTaxHSDetail,
    meta: {title: '代征税'}
  },
  {
    path: '/AntiDumping_HS',
    name: 'AntiDumping_HS',
    component: AntiDumpingHS,
    meta: {title: '反倾反补税'}
  },
  {
    path: '/AntiDumping_HSDetail',
    name: 'AntiDumping_HSDetail',
    component: AntiDumpingHSDetail,
    meta: {title: '反倾反补税详情'}
  },
  {
    path: '/AntiDumping_HSCompanyDetail',
    name: 'AntiDumping_HSCompanyDetail',
    component: AntiDumpingHSCompanyDetail,
    meta: {title: '反倾反补税公司详情'}
  },
  {
    path: '/HandBookAntiDumping',
    name: 'HandBookAntiDumping',
    component: HandBookAntiDumping,
    meta: {title: '反倾反补税'}
  },
  {
    path: '/HandBookAntiDumpingDetail',
    name: 'HandBookAntiDumpingDetail',
    component: HandBookAntiDumpingDetail,
    meta: {title: '反倾反补税详情'}
  },
  {
    path: '/HandBookAntiDumpingCompanyDetail',
    name: 'HandBookAntiDumpingCompanyDetail',
    component: HandBookAntiDumpingCompanyDetail,
    meta: {title: '反倾反补税公司详情'}
  },
  {
    path: '/HazardousChemicals_HS',
    name: 'HazardousChemicals_HS',
    component: HazardousChemicalsHS,
    meta: {title: '危化品'}
  },
  {
    path: '/HazardousChemicals_HSDetail',
    name: 'HazardousChemicals_HSDetail',
    component: HazardousChemicalsHSDetail,
    meta: {title: '危化品'}
  },
  {
    path: '/RulesSearchIndex',
    name: 'RulesSearchIndex',
    component: RulesSearchIndex,
    meta: {title: '法规文件查询'}
  },
  {
    path: '/FoodRulesSearchDetails',
    name: 'FoodRulesSearchDetails',
    component: FoodRulesSearchDetails,
    meta: {title: '食品法规文件详细'}
  },
  {
    path: '/FoodRulesSearchIndex',
    name: 'FoodRulesSearchIndex',
    component: FoodRulesSearchIndex,
    meta: {title: '食品法规文件查询'}
  },
  {
    path: '/RulesSearchDetails',
    name: 'RulesSearchDetails',
    component: RulesSearchDetails,
    meta: {title: '法规文件详细'}
  },
  {
    path: '/TradeStateByData',
    name: 'TradeStateByData',
    component: TradeStateByData,
    meta: {title: '贸易统计'}
  },
  {
    path: '/TradeStateByDataQuery',
    name: 'TradeStateByDataQuery',
    component: TradeStateByDataQuery,
    meta: {title: '贸易统计'}
  },
  {
    path: '/TradeStateByDataDetails',
    name: 'TradeStateByDataDetails',
    component: TradeStateByDataDetails,
    meta: {title: '贸易统计'}
  },
  {
    path: '/TradeStateLeaderPage',
    name: 'TradeStateLeaderPage',
    component: TradeStateLeaderPage,
    meta: {title: '统计年鉴'}
  },
  {
    path: '/TradeStateByDataEnglish',
    name: 'TradeStateByDataEnglish',
    component: TradeStateByDataEnglish,
    meta: {title: '统计年鉴（英文）'}
  },
  {
    path: '/TradeStateByDataQueryEnglish',
    name: 'TradeStateByDataQueryEnglish',
    component: TradeStateByDataQueryEnglish,
    meta: {title: '统计年鉴（英文）'}
  },
  {
    path: '/TradeStateByDataDetailsEnglish',
    name: 'TradeStateByDataDetailsEnglish',
    component: TradeStateByDataDetailsEnglish,
    meta: {title: '统计年鉴（英文）'}
  },
  {
    path: '/ExpertIndex',
    name: 'ExpertIndex',
    component: ExpertIndex,
    meta: {title: '关务咨询'}
  },
  {
    path: '/ExpertDetails',
    name: 'ExpertDetails',
    component: ExpertDetails,
    meta: {title: '关务咨询'}
  },
  {
    path: '/BindExpertIndex',
    name: 'BindExpertIndex',
    component: BindExpertIndex,
    meta: {title: '关务咨询'}
  },
  {
    path: '/BindExpertDetails',
    name: 'BindExpertDetails',
    component: BindExpertDetails,
    meta: {title: '关务咨询'}
  },
  {
    path: '/GoodsSizeQuery',
    name: 'GoodsSizeQuery',
    component: GoodsSizeQuery,
    meta: {title: '统计商品目录'}
  },
  {
    path: '/GoodsSizeQueryTOP',
    name: 'GoodsSizeQueryTOP',
    component: GoodsSizeQueryTOP,
    meta: {title: '统计商品目录'}
  },
  {
    path: '/GoodsSizeDetails',
    name: 'GoodsSizeDetails',
    component: GoodsSizeDetails,
    meta: {title: '统计商品目录'}
  },
  {
    path: '/OpenInOtherMethod',
    name: 'OpenInOtherMethod',
    component: OpenInOtherMethod,
    meta: {title: '其他浏览器下载'}
  },
  {
    path: '/PUNCode',
    name: 'PUNCode',
    component: PUNCode,
    meta: {title: 'UN编码'}
  },
  {
    path: '/PInvoices',
    name: 'PInvoices',
    component: PInvoices,
    meta: {title: '随附单据'}
  },
  {
    path: '/PUNCodeDetail',
    name: 'PUNCodeDetail',
    component: PUNCodeDetail,
    meta: {title: 'UN编码'}
  },
  {
    path: '/PInvoicesDetail',
    name: 'PInvoicesDetail',
    component: PInvoicesDetail,
    meta: {title: '随附单据'}
  },
  {
    path: '/FoodRulesSearchLeaderPage',
    name: 'FoodRulesSearchLeaderPage',
    component: FoodRulesSearchLeaderPage,
    meta: {title: '食品法规'}
  },
  {
    path: '/FoodRulesSearchOfRule',
    name: 'FoodRulesSearchOfRule',
    component: FoodRulesSearchOfRule,
    meta: {title: '食品法规'}
  },
  {
    path: '/FoodRulesSearchOfReport',
    name: 'FoodRulesSearchOfReport',
    component: FoodRulesSearchOfReport,
    meta: {title: '食品法规'}
  },
  {
    path: '/FoodRulesLoginPage',
    name: 'FoodRulesLoginPage',
    component: FoodRulesLoginPage,
    meta: {title: '食品法规'}
  },
  {
    path: '/FoodRulesRegisterPage',
    name: 'FoodRulesRegisterPage',
    component: FoodRulesRegisterPage,
    meta: {title: '食品法规'}
  },
  {
    path: '/FoodRulesFindPassPage',
    name: 'FoodRulesFindPassPage',
    component: FoodRulesFindPassPage,
    meta: {title: '食品法规'}
  },
  {
    path: '/DownloadNoticeFiles',
    name: 'DownloadNoticeFiles',
    component: DownloadNoticeFiles,
    meta: {title: '通知下载'}
  },
  {
    path: '/NodeSearchByDataDetails',
    name: 'NodeSearchByDataDetails',
    component: NodeSearchByDataDetails,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchByDataQuery',
    name: 'NodeSearchByDataQuery',
    component: NodeSearchByDataQuery,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchFindPassPage',
    name: 'NodeSearchFindPassPage',
    component: NodeSearchFindPassPage,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchLeaderPage',
    name: 'NodeSearchLeaderPage',
    component: NodeSearchLeaderPage,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchLoginPage',
    name: 'NodeSearchLoginPage',
    component: NodeSearchLoginPage,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchRegisterPage',
    name: 'NodeSearchRegisterPage',
    component: NodeSearchRegisterPage,
    meta: {title: '内控节点随手查'}
  },
  {
    path: '/NodeSearchOneDetail',
    name: 'NodeSearchOneDetail',
    component: NodeSearchOneDetail,
    meta: {title: '内控节点随手查'}
  }
]

export default new VueRouter({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js